import {Component, OnInit, NgModule, Output, EventEmitter, Input, OnChanges} from '@angular/core';
import {MamAdminService} from "../service/mam_service.component";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HttpModule} from "@angular/http";
import {DialogModule,ButtonModule,DropdownModule, InputTextModule, PanelModule, DataTableModule } from 'primeng/primeng';
import {UserGroupCheckTreeModule} from "./user_checktree.component";
import {TreeNode} from "primeng/components/common/api";
import {CompanyDropDownListModule} from "./company-drop-down-list/company-drop-down-list.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe"; // ADD THIS

@Component({
  selector: 'target-group',
  templateUrl: 'target_group.component.html'
})
export class TargetGroupComponent implements OnInit,OnChanges {
  selectedTargetLists : any;
  selectedCompany : any;
  @Input() company : any;
  @Input() setGroupTargetList : TreeNode[];
  @Output() getTargetList : EventEmitter<any> = new EventEmitter();
  private logger : Logger = new Logger();

  constructor() {}

  ngOnInit() {

  }

  ngOnChanges(){

    //this.logger.debug("TargetGroupComponent company : ",this.company);
  }

  selectedTrees(event){
    this.logger.debug("selectedTree : ",event);
    this.selectedTargetLists = event;

    this.getTargetList.emit(this.selectedTargetLists);
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

}

@NgModule({
  imports:[DialogModule,BrowserModule,ButtonModule,FormsModule,DropdownModule,ReactiveFormsModule,CommonModule,BrowserModule,HttpModule,InputTextModule,PanelModule,UserGroupCheckTreeModule, DataTableModule,CompanyDropDownListModule,TranslatePipeMoudle],
  declarations:[TargetGroupComponent],
  exports:[TargetGroupComponent],
  providers:[MamAdminService]
})
export class TargetGroupModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/target_group.component.ts